export const normalizeAddress = <T extends string>(address: T): T => {
  return address.trim().toLowerCase() as T;
};
